<template>
  <div class="theBackgroundColor">
    <div class="shareRankingBigBox">
      <div class="columnBackground">
        <img src="../assets/image/newbg_02.jpg" alt="" />
      </div>
      <div class="shareContent">
        <div class="sharedOnTheLeftSideOfThe">
          <div class="onTheLeftSideOfTheTitle">新闻列表</div>
          <ul>
            <li :class="{ colorStyle: aListOfTheStyle == 0 }"
              @click="clickOnTheListOfCategories(aListOfTheStyle = 0, 0)">
              <span class="theColumnChangeColor">通知公告</span><span class="arrow-right"></span>
            </li>
            <li :class="{ colorStyle: aListOfTheStyle == 1 }"
              @click="clickOnTheListOfCategories(aListOfTheStyle = 0, 1)">
              <span class="theColumnChangeColor">最新资讯</span><span class="arrow-right"></span>
            </li>
          </ul>
        </div>

        <div class="sharingOnTheRightSide">
          <div class="theRightSideOfTheTableFrame">
            <div class="inTopForm">
              <ul>
                <li v-for="(item, index) in informationListData" :key="index" @click="informationClickOnThe(item.id)">
                  <span class="theOrigin"></span>
                  <span class="theArticleTitle">{{ item.title }}</span><span class="theArticleDate">{{
                      leaveThe(item.createTime)
                  }}</span>
                </li>

              </ul>
            </div>


          </div>
          <div class="turnThePage">
            <el-pagination background layout="prev, pager, next" :total="numberOfPages">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, reactive } from "vue";
import {
  theArticleListsTheQuery,
  informationSection,
  announcements,
} from "../assets/api/index";
import router from "../router/index.js";
export default {
  setup() {
    const tableData = ref();
    const theListShows = ref([]);
    const currentIndex = ref(0);

    const numberOfPages = ref();
    const requestIdInformationList = reactive({
      columnId: 9,
      pageNum: 1,
      pageSize: 10,
      isAsc: false,
    });

    //获取文章列表
    const informationRequest = reactive({
      isAsc: false,
    });
    const getData = () => {
      theArticleListsTheQuery(informationRequest).then((res) => {
        tableData.value = res.data;
      });
    };
    getData();

    //栏目列表
    const theColumnList = () => {
      informationSection().then((res) => {
        theListShows.value = res.data;
      });
    };
    theColumnList();


    //资讯点击
    const informationClickOnThe = (id) => {
      router.push({ path: "informationForDetails", query: { newsid: id } });
    };
    //项目点击
    const columnClick = (value, id) => {
      requestIdInformationList.columnId = id;
      currentIndex.value = value;
      informationList();
    };




    //列表样式



    const aListOfTheStyle = ref(0);
    //资讯列表
    const informationListData = ref();
    const informationRequests = reactive({
      type: 0,
    });



    const clickOnTheListOfCategories = (value, index) => {
      informationRequests.type = index;
      aListOfTheStyle.value = index;
      informationList();
    };

    const informationList = () => {


      announcements(informationRequests).then((res) => {
        informationListData.value = res.data;



      })


    };
    informationList();


    //保留前几位
    const leaveThe = (value) => {
      return value.substr(0, 10)
    };
    return {
      //点击列表展示
      aListOfTheStyle,
      informationRequests,
      clickOnTheListOfCategories,

      tableData,
      theListShows,
      currentIndex,
      informationListData,
      requestIdInformationList,
      numberOfPages,
      informationRequest,
      leaveThe,
      informationList,
      columnClick,
      theColumnList,
      informationClickOnThe,
      getData,
    };
  },
  name: "newlist",
};
</script>

<style scoped>
.theBackgroundColor {
  background: #f4f4f4;
}

.columnBackground {
  text-align: center;
}

.shareContent {
  width: 1200px;
  margin: 0 auto;
  display: flex;
}

.colorStyle .theColumnChangeColor {
  color: #a50c0d;
}

.arrow-right {
  width: 0;
  height: 0;
  border-top: 7px solid #fff;
  border-bottom: 7px solid #fff;
  border-left: 7px solid #a50c0d;
  position: relative;
  left: 14px;
  top: 2px;
  display: none;
}

.colorStyle .arrow-right {
  display: inline-block;
}

.inTopForm {
  margin-top: 30px;
}

.theColumnChangeColor {
  font-size: 16px;
}

.inTopForm ul li {
  font-size: 15px;
  height: 23px;
  margin-bottom: 20px;
  cursor: pointer;
}

.theArticleDate {
  float: right;
  font-size: 15px;
  color: #707070;
  line-height: 23px;
}

.sharedOnTheLeftSideOfThe {
  width: 216px;
  margin-right: 20px;
  position: relative;
  bottom: 64px;
}

.onTheLeftSideOfTheTitle {
  width: 216px;
  height: 60px;
  background: #a50c0d;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  text-align: center;
  font-size: 20px;
  line-height: 60px;
  color: #fff;
}

.theOrigin {
  background: #a50c0d;
  width: 5px;
  height: 5px;
  display: inline-block;
  border-radius: 5px;
  position: relative;
  bottom: 4px;
  margin-right: 13px;
}

.sharedOnTheLeftSideOfThe ul li {
  width: 100%;
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #eee;
  text-align: center;
  cursor: pointer;
}

.sharedOnTheLeftSideOfThe ul {
  /*! border: 1px solid #eee; */
  background: #fff;
}

.sharingOnTheRightSide {
  width: 960px;
  min-height: 400px;
  background: #fff;
  border-top: 2px solid #a50c0d;
  padding: 0 31px 0 31px;
  margin-top: 20px;
  max-height: 1226px;
  margin-bottom: 30px;
  position: relative;
}

.switchOut {
  height: 55px;
  width: 100%;
  margin-top: 15px;
}

.switchOut ul li {
  width: 66px;
  height: 25px;
  float: left;
  padding: 5px;
  text-align: center;
  line-height: 25px;
  margin-left: 10px;
  border: 2px solid #a50c0d;
  font-size: 14px;
  color: #a50c0d;
}

.switchOut ul {
  float: right;
}

.inTopForm table tr th:nth-child(1) {
  text-align: start;
  text-indent: 68px;
}

.inTopForm table tr td:nth-child(1) {
  text-align: start;
  text-indent: 70px;
}

.inTopForm table tr {
  height: 53px;
}

.inTopForm table tr th {
  background: #f7f8fa;
}

.inTopForm table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #eee;
}

.inTopForm tr {
  text-align: center;
}

.inTopForm tr td {
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
}

.inTopForm table tr th {
  border-right: 1px solid #eee;
}

.topStyle {
  color: #fff !important;
  background: #a50c0d;
}

.theSerialNumber {
  line-height: 53px;
  width: 50px;
  margin-right: 29px;
}

.theExperimentalImages {
  position: relative;
  top: 13px;
  margin-right: 21px;
}

.turnThePage {
  height: 50px;
  margin-top: 9px;
  margin-bottom: 30px;
  position: absolute;
  bottom: 0;
}
</style>